// extracted by mini-css-extract-plugin
export default {"root":"XVl9E","title":"SzF23","form":"epbBh","closeBtn":"qhWW3"};